import './TextInputQuestion.scss';

export const TextInputQuestion = ({ question, description, onTextChange, text, errorMessage, isNumber }) => {
  const handleChange = (value) => {
    if (isNumber) {
      const regex = /^08+\d*$/;
      if (regex.test(value) || value === '') {
        onTextChange(value);
      }
    } else {
      onTextChange(value);
    }
  };

  return (
    <div className="text-input-question">
      <div className="question">{question}</div>
      <div className="input">
        <input type="text" value={text} onChange={(e) => handleChange(e.target.value)} className={`${errorMessage ? 'error' : ''}`} />
        <div className={`description`}>{description}</div>
      </div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};
